import styled from 'styled-components'

const ContainerAbsolute = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export default ContainerAbsolute;
